import type { PostHog } from "posthog-js/dist/module.slim";

/**
 * module.slim leaves the dead-click extension out, and the stock extension
 * would fetch its detector from PostHog's CDN at runtime anyway. The detector
 * is a small standalone script that registers itself on `window`, so it ships
 * in its own chunk and is started here.
 */
export const startDeadClicks = (posthog: PostHog): Promise<void> =>
  import("posthog-js/dist/dead-clicks-autocapture").then(() => {
    window.__PosthogExtensions__
      ?.initDeadClicksAutocapture?.(posthog, { capture_dead_swipes: false })
      .start(document);
  });
